import React from 'react'
import notfound from "assets/images/404.png"
import { Button } from 'antd'
import { useHistory } from 'react-router-dom'
const NotFound = () => {
    const history = useHistory()
  return (
    <div className='flex justify-center items-center flex-col gap-4'>
        <img  src={notfound} alt="not found" style={{
            width:"70%",
            aspectRatio:1
        }}/>
        <Button onClick={()=>history.goBack()}>Go Back</Button>
    </div>
  )
}

export default NotFound